import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* © 2022 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */

import moment from 'moment';
import { LANGUAGES_CODES_ISO_639_1, bcp47Regex } from './languageData';
import 'moment/locale/ar';
import 'moment/locale/cs';
import 'moment/locale/da';
import 'moment/locale/de';
import 'moment/locale/en-gb';
import 'moment/locale/es';
import 'moment/locale/fi';
import 'moment/locale/fr';
import 'moment/locale/hu';
import 'moment/locale/id';
import 'moment/locale/it';
import 'moment/locale/ja';
import 'moment/locale/kk';
import 'moment/locale/lt';
import 'moment/locale/lv';
import 'moment/locale/ms';
import 'moment/locale/nb';
import 'moment/locale/nl';
import 'moment/locale/pl';
import 'moment/locale/pt';
import 'moment/locale/ru';
import 'moment/locale/sv';
import 'moment/locale/th';
import 'moment/locale/tr';
import 'moment/locale/uk';
import 'moment/locale/vi';
import 'moment/locale/zh-cn';
import 'moment/locale/zh-tw';
export var getLanguageFiles = function getLanguageFiles(languageCode) {
  if (languageCode) {
    var languageData;
    try {
      languageData = require("../lang/".concat(languageCode, ".json"));
    } catch (e) {
      languageData = require('../lang/en.json');
      languageCode = 'en';
    }
    return {
      languageCode: languageCode,
      languageData: languageData
    };
  }
  return require('../lang/en.json');
};
export function getMessages(languageCode) {
  var messages;
  if (languageCode === 'en') {
    return require('../lang/en.json');
  }
  try {
    var localeMessages = require("../lang/".concat(languageCode, ".json"));
    var enMessages = require('../lang/en.json');
    messages = _objectSpread(_objectSpread({}, enMessages), localeMessages);
  } catch (error) {
    messages = require('../lang/en.json');
  }
  return messages;
}
export var getI18nString = function getI18nString(intl, id, defaultMessage) {
  return intl.formatMessage({
    id: id,
    defaultMessage: defaultMessage
  });
};
export var setMomentLocale = function setMomentLocale(locale) {
  moment.locale(locale);
};
export var getBrowserLanguage = function getBrowserLanguage() {
  if (typeof window === 'undefined') {
    return 'en';
  }

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  var language = window.navigator.language || window.navigator.userLanguage || 'en';
  var lowerLanguage = language.toLocaleLowerCase();

  // convert to lowercase comparison to support traditional Chinese on Android and ios 13/14
  if (/^zh-(hk|tw|hans-cn|hant-cn)$/.test(lowerLanguage)) {
    language = 'zh-TW';
  } else if (lowerLanguage === 'en-gb') {
    language = 'en-GB';
  }

  // except for zh-TW and en-GB, convert to the first part characters to match the translation file name
  if (language !== 'zh-TW' && language !== 'en-GB') {
    language = language.split('-')[0].toLocaleLowerCase();
  }

  // if got code 'zh' or the final output is 'zh', should convert to zh-CN to match the translation file name
  if (language === 'zh') {
    language = 'zh-CN';
  }
  return language;
};
export var validateLanguageCode = function validateLanguageCode(languageCode) {
  if (languageCode) {
    // the navigator.language will return a string representing the language version as defined in BCP 47
    var result = bcp47Regex.exec(languageCode);
    if (!result || !(result !== null && result !== void 0 && result[3])) return false;
    return LANGUAGES_CODES_ISO_639_1.includes(result === null || result === void 0 ? void 0 : result[3]);
  }
  return false;
};